import { BillingCldInfo, cldInfo } from '@/@types/children'
import apiConnect from '@/lib/api-connect'
import pako from 'pako'
import { getFrontMeta } from '@/lib/define/use-define-meta'

export const errorHandring = (err: Error, msg: string) => {
  console.error(err)
  alert(`データが正常に取得できませんでした。${msg}`)
}

const unescapeUnicode = (str: string) => {
  return str.replace(/\\u([a-fA-F0-9]{4})/g, function (x, y) {
    return String.fromCharCode(parseInt(y, 16))
  })
}

export const handleFilterPostChild = (child: any) => {
  child = child.map((cldInfo: any) => {
    delete cldInfo.img_path
    delete cldInfo.basic_survey
    delete cldInfo.target_achievements_array
    delete cldInfo.visit_target_achievements_array

    return cldInfo
  })

  return child
}

// handleGzipDataとの互換性はないのでJavaScript内部で圧縮、解凍する場合は別の関数を使用すること
export const handleUnGzipData = (responseCompressed: string) => {
  try {
    const gzipedData = atob(responseCompressed)
    const gzipedDataArray = Uint8Array.from(gzipedData, c => c.charCodeAt(0))
    const ungzipedData = pako.ungzip(gzipedDataArray, { to: 'string' })
    const output = unescapeUnicode(ungzipedData)

    const responseObject = JSON.parse(output)

    return responseObject
  } catch (error) {
    return ''
  }
}

// handleUnGzipDataとの互換性はないのでJavaScript内部で圧縮、解凍する場合は別の関数を使用すること
export const handleGzipData = (
  targetData: any,
  isErrorAlert = true
): number[] | '' => {
  try {
    const targetDataOfString = encodeURIComponent(JSON.stringify(targetData))

    // python側ではバイナリ配列で渡す必要があるため、変換はしない
    const gzipedUnit8Array = pako.gzip(targetDataOfString)

    return [...gzipedUnit8Array]
  } catch (error) {
    if (isErrorAlert && error instanceof Error) {
      errorHandring(error, `エラーコード：${getFrontMeta('gzipError')}`)
    }

    return ''
  }
}

export const getAllStaffData = async (officeId: string) => {
  const paramObject = {
    api: 'staffs',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getStaffDataByStaffId = async (
  officeId: string,
  staffId: string
) => {
  const paramObject = {
    api: 'staffs',
    dataObject: {
      act: 'list',
      officeId: officeId,
      id: staffId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getAllChildData = async (officeId: string) => {
  const paramObject = {
    api: 'basicchild',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
      isGzip: true,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getChildDataByCldId = async (
  officeId: string,
  childId: string
) => {
  const paramObject = {
    api: 'basicchild',
    dataObject: {
      act: 'list',
      id: childId,
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getChildDataOptionOfficeDataByCldId = async (
  officeId: string,
  childId: string
) => {
  const paramObject = {
    api: 'basicchild',
    dataObject: {
      act: 'list',
      id: childId,
      officeId: officeId,
      appFlg: 'P',
      isOfficeData: true,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getAllStaffActiveData = async (officeId: string) => {
  const paramObject = {
    api: 'staffs',
    dataObject: {
      act: 'list',
      active: 1,
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}
export const getAllChildActiveData = async (officeId: string) => {
  const paramObject = {
    api: 'basicchild',
    dataObject: {
      act: 'list',
      active: 1,
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

// スタッフの出欠情報取得
export const getFromToAtStaffData = async (
  from: string,
  to: string,
  officeId: string
) => {
  const paramObject = {
    api: 'at_stf',
    dataObject: {
      act: 'list',
      from: from,
      to: to,
      officeId: officeId,
      appFlg: 'P',
      isGzip: true,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getAtChildData = async (officeId: string) => {
  const paramObject = {
    api: 'at_cld',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getFromToAtChildData = async (
  from: string,
  to: string,
  officeId: string
) => {
  const paramObject = {
    api: 'at_cld',
    dataObject: {
      act: 'list',
      from: from,
      to: to,
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getNewFromToAtChildData = async (
  from: string,
  to: string,
  officeId: string
) => {
  const paramObject = {
    api: 'at_cld',
    dataObject: {
      act: 'newList',
      from: from,
      to: to,
      officeId: officeId,
      appFlg: 'P',
      isGzip: true,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getNewFromToChildAtChildData = async (
  from: string,
  to: string,
  officeId: string,
  cldId: string,
  type: string
) => {
  const paramObject: {
    api: string
    dataObject: {
      act: string
      from: string
      to: string
      officeId: string
      appFlg: string
      cldId: string
      isVisit?: boolean
    }
  } = {
    api: 'at_cld',
    dataObject: {
      act: 'newList',
      from: from,
      to: to,
      officeId: officeId,
      appFlg: 'P',
      cldId: cldId,
      isVisit: true,
    },
  }
  if (type === 'tsusyo') {
    delete paramObject.dataObject.isVisit
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

// 他事業所の児童情報検索
export const getFromOtherOfficeAtChildData = async (
  beneficiaryId: string,
  officeNumber: string,
  firstName: string,
  lastName: string,
  officeId: string
) => {
  const paramObject = {
    api: 'basicchild',
    dataObject: {
      act: 'search',
      officeId: officeId,
      beneficiaryId: beneficiaryId,
      officeNumber: officeNumber,
      firstName: firstName,
      lastName: lastName,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '')
      return
    })
}

export const getCldBookData = async (officeId: string) => {
  const paramObject = {
    api: 'cld_book',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getFromToCldBookData = async (
  from: string,
  to: string,
  officeId: string
) => {
  const paramObject = {
    api: 'cld_book',
    dataObject: {
      act: 'list',
      from: from,
      to: to,
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getFromToCldBookDataByCldId = async (
  from: string,
  to: string,
  officeId: string,
  cldId: string,
  affiliation: string
) => {
  const paramObject = {
    api: 'cld_book',
    dataObject: {
      act: 'list',
      from: from,
      to: to,
      officeId: officeId,
      cldId: cldId,
      affiliation: affiliation,
      appFlg: 'P',
      retFlg: '1',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getFromToCldBookDataByCldIdAndOfficeDataObj = async (
  from: string,
  to: string,
  officeId: string,
  cldId: string,
  affiliation: string,
  officeDataObj: object,
  isReBilling = false
) => {
  const paramObject = {
    api: 'cld_book',
    dataObject: {
      act: 'list',
      from: from,
      to: to,
      officeId: officeId,
      cldId: cldId,
      affiliation: affiliation,
      appFlg: 'P',
      retFlg: '1',
      officeDataObj: officeDataObj,
      // 再請求用の児童情報、事業所情報を使用するかしないか
      isAnewBilling: isReBilling,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getFromToCldBookAndStaffAttendanceData = async (
  from: string,
  to: string,
  officeId: string
) => {
  const paramObject = {
    api: 'cld_book',
    dataObject: {
      act: 'list',
      from: from,
      to: to,
      officeId: officeId,
      appFlg: 'P',
      addStaffAttendance: true,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getACtivityPlansData = async (officeId: string) => {
  const paramObject = {
    api: 'activity_plans',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getActivityPlansFromToData = async (
  officeId: string,
  from: string,
  to: string
) => {
  const paramObject = {
    api: 'activity_plans',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
      from: from,
      to: to,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getSchoolAllData = async (officeId: string) => {
  const paramObject = {
    api: 'school',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getSchoolDataBySchoolId = async (
  officeId: string,
  schoolId: string
) => {
  const paramObject = {
    api: 'school',
    dataObject: {
      act: 'list',
      id: schoolId,
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getClosedSchoolAllData = async (officeId: string) => {
  const paramObject = {
    api: 'closed_school',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getFromToClosedSchoolAllData = async (
  schoolId: string,
  from: string,
  to: string,
  officeId: string
) => {
  const paramObject = {
    api: 'closed_school',
    dataObject: {
      act: 'list',
      schoolId: schoolId,
      from: from,
      to: to,
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getAllBusinessDayData = async (officeId: string) => {
  const paramObject = {
    api: 'holiday',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getOfficeData = async (officeId: string) => {
  const paramObject = {
    api: 'office',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getOfficeIdData = async (officeId: string) => {
  const paramObject = {
    api: 'office',
    dataObject: {
      act: 'list',
      id: officeId,
      // officeId: officeId,
      // appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getAllCarData = async (officeId: string) => {
  const paramObject = {
    api: 'car',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getAllActivityData = async (officeId: string) => {
  const paramObject = {
    api: 'activity',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getTackingAllData = async (officeId: string) => {
  const paramObject = {
    api: 'tacking',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getTackingTargetDateData = async (
  date: string,
  officeId: string
) => {
  const paramObject = {
    api: 'tacking',
    dataObject: {
      act: 'list',
      date: date,
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getSendAllData = async (officeId: string) => {
  const paramObject = {
    api: 'send',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getSendTargetDateData = async (date: string, officeId: string) => {
  const paramObject = {
    api: 'send',
    dataObject: {
      act: 'list',
      date: date,
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getAchievementsData = async (officeId: string) => {
  const paramObject = {
    api: 'achievements',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getAchievementsDataByCldId = async (
  cldId: string,
  officeId: string,
  affiliation: string
) => {
  const paramObject = {
    api: 'achievements',
    dataObject: {
      act: 'list',
      cldId: cldId,
      officeId: officeId,
      appFlg: 'P',
      affiliation: affiliation,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch(err => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getAchievementsDataByCldIdAndTargetDate = async (
  cldId: string,
  year: number,
  month: number,
  officeId: string,
  affiliation: string,
  isAnewBilling = false // trueの場合、再請求
) => {
  const paramObject = {
    api: 'achievements',
    dataObject: {
      act: 'list',
      cldId: cldId,
      officeId: officeId,
      year: year,
      month: month,
      affiliation: affiliation,
      isCollect: true,
      appFlg: 'P',
      isChildBillingGroup: true,
      isAnewBilling: isAnewBilling,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch(err => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getAchievementsDataByTargetDate = async (
  year: number,
  month: number,
  officeId: string
) => {
  const paramObject = {
    api: 'achievements',
    dataObject: {
      act: 'list',
      officeId: officeId,
      year: year,
      month: month,
      appFlg: 'P',
      isCollect: true,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch(err => {
      window.close()
      return
    })
}

export const getBulkCldAchievementsDataByTargetDate = async (
  year: number,
  month: number,
  officeId: string,
  childList: { cldId: string; affiliation: string }[],
  isAnewBilling = false // trueの場合、再請求
) => {
  const paramObject = {
    api: 'achievements',
    dataObject: {
      act: 'list',
      officeId: officeId,
      year: year,
      month: month,
      appFlg: 'P',
      isCollect: true,
      isChildData: true,
      childList: childList,
      isAnewBilling: isAnewBilling,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch(err => {
      window.close()
      return
    })
}

export const getSignByCldId = async (cldId: string, officeId: string) => {
  const paramObject = {
    api: 'sign',
    dataObject: {
      act: 'list_data',
      officeId: officeId,
      appFlg: 'P',
      cldId: cldId,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getSignByCldIdFromPath = async (
  signPath: string,
  officeId: string
) => {
  const paramObject = {
    api: 'sign',
    dataObject: {
      act: 'list_path_data',
      officeId: officeId,
      appFlg: 'P',
      signPath: signPath,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getClaimData = async (officeId: string) => {
  const paramObject = {
    api: 'claim',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}
export const getAllClaimData = async (officeId: string) => {
  const paramObject = {
    api: 'claim',
    dataObject: {
      act: 'all_list_name',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

// 請求データ児童一覧取得
export const getFromToBillingChildData = async (
  officeId: string,
  date: string
) => {
  const paramObject = {
    api: 'billing',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      isGzip: true,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

// 請求データ児童一覧取得（令和６年度報酬改定対応）
export const getNewFromToBillingChildData = async (
  officeId: string,
  date: string
) => {
  const paramObject = {
    api: 'new_billing',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      isGzip: true,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

// 再請求データ児童一覧取得
export const getFromToReBillingChildData = async (
  officeId: string,
  date: string
) => {
  const paramObject = {
    api: 'anew_billing',
    dataObject: {
      act: 'anewDayroboList',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      isInvoice: true,
      isGzip: true,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

// 再請求データ児童一覧取得（令和６年度報酬改定対応）
export const getFromToNewReBillingChildData = async (
  officeId: string,
  date: string
) => {
  const paramObject = {
    api: 'new_anew_billing',
    dataObject: {
      act: 'anewDayroboList',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      isInvoice: true,
      isGzip: true,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

//各児童の請求情報(様式第二/上限管理)の取得
export const getFromToClaimChildDataByCldId = async (
  officeId: string,
  date: string,
  affiliation: string,
  cldId: string,
  visitChildFlg = '0'
) => {
  const paramObject = {
    api: 'billing',
    dataObject: {
      act: 'beGet',
      officeId: officeId,
      appFlg: 'P',
      affiliation: affiliation,
      date: date,
      cldId: cldId,
      visitChildFlg: visitChildFlg,
    },
  }

  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

//各児童の請求情報(様式第二/上限管理)の取得（令和６年度報酬改定対応）
export const getNewFromToClaimChildDataByCldId = async (
  officeId: string,
  date: string,
  affiliation: string,
  cldId: string,
  visitChildFlg = '0'
) => {
  const paramObject = {
    api: 'new_billing',
    dataObject: {
      act: 'beGet',
      officeId: officeId,
      appFlg: 'P',
      affiliation: affiliation,
      date: date,
      cldId: cldId,
      visitChildFlg: visitChildFlg,
    },
  }

  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

//まとめて児童の請求情報(様式第二)の取得
export const getBulkFromToClaimChildDataByCldId = async (
  officeId: string,
  date: string,
  childList: string[]
) => {
  const paramObject = {
    api: 'billing',
    dataObject: {
      act: 'getCollectDetailsList',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      childList: childList,
    },
  }

  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

//まとめて児童の請求情報(様式第二)の取得（令和６年度報酬改定対応）
export const getNewBulkFromToClaimChildDataByCldId = async (
  officeId: string,
  date: string,
  childList: string[]
) => {
  const paramObject = {
    api: 'new_billing',
    dataObject: {
      act: 'getCollectDetailsList',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      childList: childList,
    },
  }

  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

//まとめて児童の請求情報(上限管理)の取得
export const getBulkFromToClaimChildUpperLimitDataByCldId = async (
  officeId: string,
  date: string,
  childList: string[]
) => {
  const paramObject = {
    api: 'billing',
    dataObject: {
      act: 'getCollectUpperLimitList',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      childList: childList,
    },
  }

  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

//まとめて児童の請求情報(上限管理)の取得（令和６年度報酬改定対応）
export const getNewBulkFromToClaimChildUpperLimitDataByCldId = async (
  officeId: string,
  date: string,
  childList: string[]
) => {
  const paramObject = {
    api: 'new_billing',
    dataObject: {
      act: 'getCollectUpperLimitList',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      childList: childList,
    },
  }

  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

//利用者負担額一覧表の取得
export const getFromToClaimAmountListDataByCldId = async (
  officeId: string,
  date: string,
  cldId: string,
  child: any[],
  isReBilling = false
) => {
  const paramObject = {
    api: 'billing',
    dataObject: {
      act: 'getAmountList',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      cldId: cldId,
      child: child,
      // 再請求用の児童情報を使用するかしないか
      isAnewBilling: isReBilling,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

//利用者負担額一覧表の取得（令和６年度報酬改定対応）
export const getNewFromToClaimAmountListDataByCldId = async (
  officeId: string,
  date: string,
  cldId: string,
  child: any[],
  isReBilling = false
) => {
  const paramObject = {
    api: 'new_billing',
    dataObject: {
      act: 'getAmountList',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      cldId: cldId,
      child: child,
      // 再請求用の児童情報を使用するかしないか
      isAnewBilling: isReBilling,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

//まとめて利用者負担額一覧表の取得
export const getBulkFromToClaimAmountListDataByCldId = async (
  officeId: string,
  date: string,
  child: cldInfo[]
) => {
  const paramObject = {
    api: 'billing',
    dataObject: {
      act: 'getCollectAmountList',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      child: child,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

//まとめて利用者負担額一覧表の取得（令和６年度報酬改定対応）
export const getNewBulkFromToClaimAmountListDataByCldId = async (
  officeId: string,
  date: string,
  child: cldInfo[]
) => {
  const paramObject = {
    api: 'new_billing',
    dataObject: {
      act: 'getCollectAmountList',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      child: child,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

// サマリー(様式第一)データの取得
export const getFromToClaimSummaryDataByofficeId = async (
  officeId: string,
  date: string,
  child: BillingCldInfo[],
  isAnewBilling: boolean
) => {
  child = handleFilterPostChild(child)

  const paramObject = {
    api: 'billing',
    dataObject: {
      act: 'beSummaryGet',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      child: child,
      isAnewBilling: isAnewBilling,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

// サマリー(様式第一)データの取得（令和６年度報酬改定対応）
export const getNewFromToClaimSummaryDataByofficeId = async (
  officeId: string,
  date: string,
  child: BillingCldInfo[],
  isAnewBilling: boolean
) => {
  child = handleFilterPostChild(child)

  const paramObject = {
    api: 'new_billing',
    dataObject: {
      act: 'beSummaryGet',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      child: child,
      isAnewBilling: isAnewBilling,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getFromToClaimParentsChildData = async (
  officeId: string,
  date: string
) => {
  const paramObject = {
    api: 'invoice',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      isGzip: true,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

// （令和６年度報酬改定対応）
export const getNewFromToClaimParentsChildData = async (
  officeId: string,
  date: string
) => {
  const paramObject = {
    api: 'new_invoice',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      isGzip: true,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

//各児童の保護者請求 - 代理受領額通知書(様式第二)の取得
export const getFromToClaimChildDataByCldIdOfParents = async (
  officeId: string,
  date: string,
  affiliation: string,
  cldId: string,
  visitChildFlg = '0'
) => {
  const paramObject = {
    api: 'billing',
    dataObject: {
      act: 'beGet',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      affiliation: affiliation,
      cldId: cldId,
      visitChildFlg: visitChildFlg,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      return
    })
}

//各児童の保護者請求 - 代理受領額通知書(様式第二)の取得（令和６年度報酬改定対応）
export const getNewFromToClaimChildDataByCldIdOfParents = async (
  officeId: string,
  date: string,
  affiliation: string,
  cldId: string,
  visitChildFlg = '0'
) => {
  const paramObject = {
    api: 'new_billing',
    dataObject: {
      act: 'beGet',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      affiliation: affiliation,
      cldId: cldId,
      visitChildFlg: visitChildFlg,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      return
    })
}

// 利用料明細 / 請求書取得
export const getFromToParentsClaimChildDataByCldId = async (
  officeId: string,
  date: string,
  cldId: string
) => {
  const paramObject = {
    api: 'invoice',
    dataObject: {
      act: 'beGet',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      cldId: cldId,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      return
    })
}

// 利用料明細 / 請求書取得（令和６年度報酬改定対応）
export const getNewFromToParentsClaimChildDataByCldId = async (
  officeId: string,
  date: string,
  cldId: string
) => {
  const paramObject = {
    api: 'new_invoice',
    dataObject: {
      act: 'beGet',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      cldId: cldId,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      return
    })
}

// まとめて利用料明細 / 請求書取得
export const getBulkFromToParentsClaimChildDataByCldId = async (
  officeId: string,
  date: string,
  childList: string[]
) => {
  const paramObject = {
    api: 'invoice',
    dataObject: {
      act: 'beGetCollect',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      childList: childList,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      return
    })
}

// まとめて利用料明細 / 請求書取得（令和６年度報酬改定対応）
export const getNewBulkFromToParentsClaimChildDataByCldId = async (
  officeId: string,
  date: string,
  childList: string[]
) => {
  const paramObject = {
    api: 'new_invoice',
    dataObject: {
      act: 'beGetCollect',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      childList: childList,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      return
    })
}

// 資格情報取得
export const getQualificationList = async (officeId: string) => {
  const paramObject = {
    api: 'qualification',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      return
    })
}

// 再請求様式第二再計算取得 & 更新
export const getReBillingChildDataByCldData = async (
  officeId: string,
  date: string,
  office: { [key: string]: any },
  child: { [key: string]: any }[],
  achievements: { [key: string]: any }[],
  visitAchievements: { [key: string]: any }[]
) => {
  const paramObject = {
    api: 'anew_billing',
    dataObject: {
      act: 'anewBeGet',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      office: office,
      child: child,
      achievements: achievements,
      // eslint-disable-next-line @typescript-eslint/camelcase
      visit_achievements: visitAchievements,
    },
  }

  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

// 再請求様式第二再計算取得 & 更新（令和６年度報酬改定対応）
export const getNewReBillingChildDataByCldData = async (
  officeId: string,
  date: string,
  office: { [key: string]: any },
  child: { [key: string]: any }[],
  achievements: { [key: string]: any }[],
  visitAchievements: { [key: string]: any }[]
) => {
  const paramObject = {
    api: 'new_anew_billing',
    dataObject: {
      act: 'anewBeGet',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      office: office,
      child: child,
      achievements: achievements,
      // eslint-disable-next-line @typescript-eslint/camelcase
      visit_achievements: visitAchievements,
    },
  }

  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getRebillingSummaryByOfficeId = async (
  officeId: string,
  date: string,
  office: { [key: string]: any },
  child: { [key: string]: any }[],
  achievements: { [key: string]: any }[],
  billing: { [key: string]: any }[]
) => {
  const paramObject = {
    api: 'invoice',
    dataObject: {
      act: 'anewBeGet',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      office: office,
      child: child,
      achievements: achievements,
      billing: billing,
    },
  }

  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getNewRebillingSummaryByOfficeId = async (
  officeId: string,
  date: string,
  office: { [key: string]: any },
  child: { [key: string]: any }[],
  achievements: { [key: string]: any }[],
  billing: { [key: string]: any }[]
) => {
  const paramObject = {
    api: 'new_invoice',
    dataObject: {
      act: 'anewBeGet',
      officeId: officeId,
      appFlg: 'P',
      date: date,
      office: office,
      child: child,
      achievements: achievements,
      billing: billing,
    },
  }

  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getCldBookAndAchievementsDataByDate = async (
  officeId: string,
  date: string
) => {
  const paramObject = {
    api: 'achievements',
    dataObject: {
      act: 'list_achievements_and_cldbook',
      officeId: officeId,
      date: date,
      appFlg: 'P',
      isCollect: true,
      isGzip: true,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const updateAchievementsAndGetTargetCldBookCnt = async (
  officeId: string,
  date: {
    year: string
    month: string
  }
) => {
  const paramObject = {
    api: 'automaticachievements',
    dataObject: {
      act: 'insert',
      officeId: officeId,
      year: date.year,
      month: date.month,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const updateNewAchievementsAndGetTargetCldBookCnt = async (
  officeId: string,
  date: {
    year: string
    month: string
  }
) => {
  const paramObject = {
    api: 'automaticnewachievements',
    dataObject: {
      act: 'insert',
      officeId: officeId,
      year: date.year,
      month: date.month,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getListReBillingData = async (officeId: string) => {
  const paramObject = {
    api: 'anew_billing',
    dataObject: {
      act: 'listBillingData',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

// （令和６年度報酬改定対応）
export const getListNewReBillingData = async (officeId: string) => {
  const paramObject = {
    api: 'new_anew_billing',
    dataObject: {
      act: 'listBillingData',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getBillingAllDataOfReBilliing = async (
  officeId: string,
  paramDate: string
) => {
  const paramObject = {
    api: 'anew_billing',
    dataObject: {
      act: 'getCsvMakingData',
      officeId: officeId,
      appFlg: 'P',
      date: paramDate,
      isGzip: true,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getNewBillingAllDataOfReBilliing = async (
  officeId: string,
  paramDate: string
) => {
  const paramObject = {
    api: 'new_anew_billing',
    dataObject: {
      act: 'getCsvMakingData',
      officeId: officeId,
      appFlg: 'P',
      date: paramDate,
      isGzip: true,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getLineAccountData = async (officeId: string) => {
  const paramObject = {
    api: 'line',
    dataObject: {
      act: 'list_account',
      appFlg: 'P',
      groupId: officeId,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, 'データが正常に取得できませんでした。リロードします。')
      location.reload()
      return
    })
}

export const getLineHistoryData = async (
  officeId: string,
  lineId: string,
  staffData: { [key: string]: string }
) => {
  const paramObject = {
    api: 'line',
    dataObject: {
      act: 'list_history',
      appFlg: 'P',
      groupId: officeId,
      lineId: lineId,
      isAlways: false,
      lastUpdatedByStaffId: staffData.staff_id,
      lastUpdatedByStaffName: `${staffData.last_name}${staffData.first_name}`,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(
        err,
        'チャットのデータが取得できませんでした。リロードします。'
      )
      location.reload()
      return
    })
}

export const updateLineMessageData = async (
  officeId: string,
  lineIdList: { [key: string]: string | { [key: string]: string }[] }[],
  messageArray: { [key: string]: string | boolean }[],
  staffData: { [key: string]: string }
) => {
  const paramObject = {
    api: 'line',
    dataObject: {
      act: 'message',
      appFlg: 'P',
      groupId: officeId,
      lineIdList: lineIdList,
      messageList: messageArray,
      lastUpdatedByStaffId: staffData.staff_id,
      // lastUpdatedByStaffName: `${staffData.last_name}${staffData.first_name}`
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, 'メッセージが送信できませんでした。リロードします。')
      location.reload()
      return
    })
}

export const getLineSegmentHistoryData = async (officeId: string) => {
  const paramObject = {
    api: 'line',
    dataObject: {
      act: 'list_message',
      appFlg: 'P',
      groupId: officeId,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, 'メッセージが送信できませんでした。リロードします。')
      location.reload()
      return
    })
}

export const getLineSegmentHistoryImage = async (
  officeId: string,
  imgPath: string
) => {
  const paramObject = {
    api: 'line',
    dataObject: {
      act: 'list_base64',
      appFlg: 'P',
      groupId: officeId,
      imgPath: imgPath,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, 'メッセージが送信できませんでした。リロードします。')
      location.reload()
      return
    })
}

export const getTutoringPlanCldList = async (
  officeId: string,
  cldId: string
) => {
  const paramObject = {
    api: 'tutoringplan',
    dataObject: {
      act: 'list_time',
      appFlg: 'P',
      officeId: officeId,
      cldId: cldId,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '個別支援計画の提供時間が取得できませんでした')
      return
    })
}

export const getTutoringPlanCldData = async (
  officeId: string,
  cldId: string
) => {
  const paramObject = {
    api: 'tutoringplan',
    dataObject: {
      act: 'list',
      appFlg: 'P',
      officeId: officeId,
      cldId: cldId,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, 'データが正常に取得できませんでした')
      return
    })
}

export const getVisitTutoringPlanCldData = async (
  officeId: string,
  cldId: string
) => {
  const paramObject = {
    api: 'tutoringplan',
    dataObject: {
      act: 'visit_list',
      appFlg: 'P',
      officeId: officeId,
      cldId: cldId,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, 'データが正常に取得できませんでした')
      return
    })
}

export const getTutoringPlanStaffData = async (officeId: string) => {
  const paramObject = {
    api: 'staffs',
    dataObject: {
      act: 'list',
      officeId: officeId,
      appFlg: 'S',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getTutoringPlanSignByCldIdFromPath = async (
  signPath: string,
  officeId: string
) => {
  const paramObject = {
    api: 'sign',
    dataObject: {
      act: 'list_path_data',
      officeId: officeId,
      appFlg: 'S',
      signPath: signPath,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const postTutoringPlan = async (dataObject: any) => {
  const paramObject = {
    api: 'tutoringplan',
    dataObject: dataObject,
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, 'データが正常に取得できませんでした')
      return
    })
}

export const getPartnershipDataByCodomonTime = async (
  serviceId: number,
  memberIdList: number[],
  from: string,
  to: string,
  officeId: string
) => {
  const paramObject = {
    api: 'partnership',
    dataObject: {
      act: 'list',
      appFlg: 'P',
      serviceId: serviceId,
      memberIdList: memberIdList,
      from: from,
      to: to,
      officeId: officeId,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, 'データが正常に取得できませんでした')
      return
    })
}

export const getPickUpInfo = async (
  from: string,
  to: string,
  officeId: string
) => {
  const paramObject = {
    api: 'pick_send',
    dataObject: {
      act: 'get_list_by_from_to',
      appFlg: 'P',
      from: from,
      to: to,
      officeId: officeId,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, 'データが正常に取得できませんでした')
      return
    })
}

export const getAttendanceInfoForPickUp = async (
  from: string,
  to: string,
  officeId: string
) => {
  const paramObject = {
    api: 'pick_send',
    dataObject: {
      act: 'get_at_child_list_by_from_to',
      appFlg: 'P',
      from: from,
      to: to,
      officeId: officeId,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, 'データが正常に取得できませんでした')
      return
    })
}

export const postPickUpInfo = async (dataObject: any) => {
  const paramObject = {
    api: 'pick_send',
    dataObject: dataObject,
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, 'データが正常に更新できませんでした')
      return
    })
}

export const deletePickUpInfo = async (id: string, officeId: string) => {
  const paramObject = {
    api: 'pick_send',
    dataObject: {
      act: 'delete',
      id: id,
      officeId: officeId,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, 'データが正常に削除できませんでした')
      return
    })
}

export const getAnalysisCsv = async (officeId: string) => {
  const paramObject = {
    api: 'new_anew_billing',
    dataObject: {
      act: 'getAnalysisCSV',
      officeId: officeId,
      appFlg: 'P',
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, 'データが正常に取得できませんでした')
      return
    })
}

export const getPartnershipDataByCodomonChild = async (
  serviceId: number,
  memberIdList: number[]
) => {
  const paramObject = {
    api: 'partnership',
    dataObject: {
      act: 'list_child',
      appFlg: 'P',
      serviceId: serviceId,
      memberIdList: memberIdList,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const getAlertInfo = async (officeId: string) => {
  const paramObject = {
    api: 'alert',
    dataObject: {
      act: 'get_json',
      officeId: officeId,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const updateAlertInfo = async (
  officeId: string,
  cldId: string,
  alertType: string
) => {
  const paramObject = {
    api: 'alert',
    dataObject: {
      act: 'update_json',
      officeId: officeId,
      cldId: cldId,
      alertType: alertType,
    },
  }
  return await apiConnect
    .postToApiGateway(paramObject.api, paramObject.dataObject)
    .catch((err: Error): undefined => {
      errorHandring(err, '前のページに戻ります。')
      window.history.back()
      return
    })
}

export const deleteTutoringPlan = async ({
  officeId,
  planId,
}: {
  officeId: string
  planId: string
}) => {
  const paramObject = {
    api: 'tutoringplan',
    dataObject: {
      act: 'delete',
      officeId: officeId,
      id: planId,
    },
  }
  return await apiConnect.postToApiGateway(
    paramObject.api,
    paramObject.dataObject
  )
}

export const deleteVisitTutoringPlan = async ({
  officeId,
  planId,
}: {
  officeId: string
  planId: string
}) => {
  const paramObject = {
    api: 'tutoringplan',
    dataObject: {
      act: 'visit_delete',
      officeId: officeId,
      id: planId,
    },
  }
  return await apiConnect.postToApiGateway(
    paramObject.api,
    paramObject.dataObject
  )
}
